import { Query } from '@/app/tracking/api';
import { QuizSessionPhase } from './quiz-session-phase';

export interface QueryQuizSessionsTrackingQueryPayload {
}

export interface QueryQuizSessionsTrackingQueryResult {
  sessions: QuizSession[]
}

interface QuizSession {
  id: string
  quizId: string
  aspect: string
  type: '' | string
  phase: QuizSessionPhase
  content: unknown
}

export const QueryQuizSessionsTrackingQueryName = 'query-quiz-sessions' as const
export type QueryQuizSessionsTrackingQuery =
      Query<typeof QueryQuizSessionsTrackingQueryName, QueryQuizSessionsTrackingQueryPayload, QueryQuizSessionsTrackingQueryResult>
